import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Twitter, Mail } from "lucide-react";
import { BrandWordmark } from "@/components/Brand";

const COLS = [
    {
        title: "Engage",
        links: [
            { to: "/clients", label: "For Brands" },
            { to: "/doctor", label: "Dr. Aangan Theory" },
            { to: "/academy", label: "Aangan Academy" },
            { to: "/careers", label: "Careers" },
        ],
    },
    {
        title: "Account",
        links: [
            { to: "/my", label: "My Dashboard" },
            { to: "/status", label: "Track an application" },
            { to: "/admin/login", label: "Admin" },
        ],
    },
];

export default function Footer() {
    return (
        <footer className="border-t border-white/8 mt-32 relative overflow-hidden" data-testid="site-footer">
            <div className="absolute inset-0 bg-warm-noise opacity-50 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <BrandWordmark height={32} />
                        <p className="text-white/55 text-sm leading-relaxed max-w-md mt-6">
                            We help people, brands and businesses become impossible to ignore. Strategic
                            thinking. Creative excellence. Meaningful impact.
                        </p>
                        <a
                            href="mailto:info@aangantheory.com"
                            className="mt-8 inline-flex items-center gap-2 text-white hover:text-saffron transition-colors text-sm"
                            data-testid="footer-email-link"
                        >
                            <Mail size={14} />
                            info@aangantheory.com
                        </a>
                    </div>

                    {COLS.map((c) => (
                        <div key={c.title} className="md:col-span-2">
                            <div className="eyebrow mb-4">{c.title}</div>
                            <ul className="space-y-3">
                                {c.links.map((l) => (
                                    <li key={l.to}>
                                        <Link
                                            to={l.to}
                                            className="text-white/75 hover:text-saffron text-sm transition-colors"
                                            data-testid={`footer-link-${l.to.replace("/", "")}`}
                                        >
                                            {l.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <div className="md:col-span-3">
                        <div className="eyebrow mb-4">Follow</div>
                        <div className="flex flex-wrap gap-2">
                            {[
                                { href: "https://www.instagram.com/aangan.theory/", icon: Instagram, label: "instagram" },
                                { href: "https://www.facebook.com/profile.php?id=61590480183746", icon: Facebook, label: "facebook" },
                                { href: "https://www.youtube.com/@AanganTheory", icon: Youtube, label: "youtube" },
                                { href: "https://x.com/AanganTheory", icon: Twitter, label: "x" },
                            ].map((s) => (
                                <a
                                    key={s.label}
                                    href={s.href}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="w-10 h-10 grid place-items-center border border-white/10 text-white/70 hover:text-saffron hover:border-saffron transition-colors"
                                    data-testid={`footer-social-${s.label}`}
                                    aria-label={s.label}
                                >
                                    <s.icon size={16} />
                                </a>
                            ))}
                        </div>
                        <p className="text-white/45 text-xs mt-8">www.aangantheory.com</p>
                    </div>
                </div>

                <div className="hairline mt-16 mb-8" />
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/45">
                    <div>© {new Date().getFullYear()} Aangan Theory. Made to Matter.</div>
                    <div className="font-mono uppercase tracking-widest">Launching · 04 July</div>
                </div>
            </div>
        </footer>
    );
}
